import {ChangeDetectorRef, Component} from '@angular/core';
import {TableService} from "../../../core/services/table.service";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {GeneralService} from "../../../core/services/general.service";
import {ClientService} from "../../../core/services/client.service";
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {NgForOf, NgIf} from "@angular/common";
import {PasswordComponent} from "../../admin/user/password/password.component";
import {CommonSvgIconsComponent} from "../../../shared/components/common-svg-icons/common-svg-icons.component";
import {ConfirmComponent} from "../../../shared/components/generalModals/confirm/confirm.component";
import {BillingService} from "../../../core/services/billing.service";
import {NewBillingComponent} from "./new-billing/new-billing.component";

@Component({
  selector: 'app-profile',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    NgIf,
    NgForOf,
    CommonSvgIconsComponent
  ],
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.scss'
})
export class ProfileComponent {
  dataClient: any = {};
  countryList: any[] = [];
  cityList: any[] = [];
  useList: any[] = [];
  regimenList: any[] = [];

  public clientForm: FormGroup;
  public dataForm: FormGroup;

  constructor(public service: ClientService, private modalService: NgbModal, private billingService: BillingService, private tableService: TableService, private fb: FormBuilder, private generalService: GeneralService, private cdr: ChangeDetectorRef) {
    this.clientForm = this.fb.group({
      id:[null, Validators.required],
      email: [null, [Validators.required, Validators.email]],
    });
    this.dataForm = this.fb.group({
      id:[null, Validators.required],
      user_id: [null, [Validators.required]],
      ciudad: [null, [Validators.required]],
      movil: [null, [Validators.required]],
      name: [null, [Validators.required]],
      pais: [null, [Validators.required]],
      regimen_fiscal: [null, [Validators.required]],
      telefono: [null, [Validators.required]],
      uso_comun_servicio: [null, [Validators.required]],
    });
  }

  ngOnInit() {
    this.loadList({"conditionColumn":"configurableListsField",
      "conditionValue":"País",
      "idColumn":"idconfigurableLists",
      "table":"confList",
      "valueColumn":"configurableListsCode"}, (value) => {this.countryList = value;});

    this.loadList({"conditionColumn":"configurableListsField",
      "conditionValue":"Ciudad",
      "idColumn":"idconfigurableLists",
      "table":"confList",
      "valueColumn":"configurableListsCode"}, (value) => {this.cityList = value;});

    this.loadList({"conditionColumn":"configurableListsField",
      "conditionValue":"Uso servicio",
      "idColumn":"idconfigurableLists",
      "table":"confList",
      "valueColumn":"configurableListsCode"}, (value) => {this.useList = value;});

    this.loadList({"conditionColumn":"configurableListsField",
      "conditionValue":"Régimen fiscal",
      "idColumn":"idconfigurableLists",
      "table":"confList",
      "valueColumn":"configurableListsCode"}, (value) => {this.regimenList = value;});

    this.getData();
  }

  getData(){
    //Cargar datos del formulario
    this.service.getData().subscribe(
        (res: any) => {
          if (res.error) {
            this.generalService.showMessage('warn', 'Error ' + res.idError + '!. ' + res.message);
          } else {
            this.dataClient = res.message;
            this.clientForm.setValue({
              id: this.dataClient.user.id,
              email: this.dataClient.user.email,
            });
            this.dataForm.setValue({
              id: this.dataClient.client.id,
              user_id: this.dataClient.client.user_id,
              name: this.dataClient.client.name,
              movil: this.dataClient.client.movil,
              telefono: this.dataClient.client.telefono,
              pais: this.dataClient.client.pais,
              ciudad: this.dataClient.client.ciudad,
              uso_comun_servicio: this.dataClient.client.uso_comun_servicio,
              regimen_fiscal: this.dataClient.client.regimen_fiscal,
            });
          }
        },
        (err: any) => {
          this.generalService.showMessage('warn', 'Error! ' + JSON.stringify(err));
        }
    );
  }

  sendClient(){
    if (this.clientForm.valid) {
      this.service.saveClient({data: this.clientForm.value}).subscribe(
          (res: any) => {
            if (res.error) {
              this.generalService.showMessage('warn', 'Error ' + res.idError + '!. ' + res.message);
            } else {
              this.generalService.showMessage('success', res.message);
            }
          },
          (err: any) => {
            this.generalService.showMessage('warn', 'Error! ' + JSON.stringify(err));
          }
      );
    } else {
      this.clientForm.markAllAsTouched();
      this.generalService.showMessage('warn', 'LLene toda la información solicitada');
    }
  }

  sendData(){
    if (this.dataForm.valid) {
      this.service.saveData({data: this.dataForm.value}).subscribe(
          (res: any) => {
            if (res.error) {
              this.generalService.showMessage('warn', 'Error ' + res.idError + '!. ' + res.message);
            } else {
              this.generalService.showMessage('success', res.message);
            }
          },
          (err: any) => {
            this.generalService.showMessage('warn', 'Error! ' + JSON.stringify(err));
          }
      );
    } else {
      this.dataForm.markAllAsTouched();
      this.generalService.showMessage('warn', 'LLene toda la información solicitada');
    }
  }

  changePass(): void {
    let row = {
      'users.id': this.dataClient.user.id
    }
    let modal = this.modalService.open(PasswordComponent, { centered: true });
    modal.componentInstance.data = row;
    modal.componentInstance.confirmAction = (data: any) => {
      //ToDO
    };
  }

  loadList(config: any, setVariable: (value: any) => void):void {
    this.tableService.loadSelectOptions(config).subscribe(
        (res: any) => {
          if (res.error) {
            this.generalService.showMessage('warn', 'Error ' + res.idError + '!. ' + res.message);
            setVariable([]);
          } else {
            setVariable(res['message']);
          }
        },
        (err) => {
          this.generalService.showMessage('warn', 'Error! ' + JSON.stringify(err));
          setVariable([]);
        }
    );
  }

  /**
   * Datos de facturas
   */
  newRow(): void {
    let modal = this.modalService.open(NewBillingComponent, { centered: true, windowClass: 'modal-xl modal-dialog-centered' });
    modal.componentInstance.data = {item: null, idClient: this.dataClient.client.id};
    modal.componentInstance.confirmAction = (data: any) => {
      modal.close();
      this.getData();
    };
  }
  editRow(item: any): void{
    let modal = this.modalService.open(NewBillingComponent, { centered: true, windowClass: 'modal-xl modal-dialog-centered' });
    modal.componentInstance.data = {item, idClient: this.dataClient.client.id};
    modal.componentInstance.confirmAction = (data: any) => {
      modal.close();
      this.getData();
    };
  }

  downloadPDF(url: any = "") {
    if (url) {
      window.open(url, '_blank'); // Abre el PDF en una nueva ventana
    }
  }

  //Función para eliminar un registro
  deleteRow(item: any): void{
    let modal = this.modalService.open(ConfirmComponent, { centered: true });
    modal.componentInstance.image = "assets/images/gif/danger.gif";
    modal.componentInstance.title = "¿Estás seguro de que deseas eliminar este registro?";
    modal.componentInstance.description = "Esta acción no se puede deshacer. ¿Deseas continuar con la eliminación?";
    modal.componentInstance.refModel = modal;
    modal.componentInstance.confirmAction = () => {
      this.billingService.delete({id: item.id}).subscribe(
          (res: any) => {
            if (res.error) {
              this.generalService.showMessage('warn', 'Error ' + res.idError + '!. ' + res.message);
            } else {
              this.generalService.showMessage('success', res.message);
              modal.close();
              this.getData();
            }
          },
          (err: any) => {
            this.generalService.showMessage('warn', 'Error! ' + JSON.stringify(err));
          }
      );
    };
  }
}
